import React from 'react';
import { formatCurrency, formatDate } from '../../services/api';
import LoadingSpinner from '../UI/LoadingSpinner';

const OutstandingLoans = ({ data, loading }) => {
  if (loading) {
    return <LoadingSpinner />;
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-6">
        <p className="text-gray-500">No outstanding loans</p>
      </div>
    );
  }

  const getDaysOverdue = (loanDate) => {
    const today = new Date();
    const loan = new Date(loanDate);
    const diffTime = Math.abs(today - loan);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const getOverdueColor = (days) => {
    if (days > 90) return 'text-red-600';
    if (days > 30) return 'text-yellow-600';
    return 'text-green-600';
  };

  return (
    <div className="overflow-hidden">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-primary-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Loan
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Customer
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Amount
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Outstanding
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Days
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Status
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data.map((loan) => {
            const days = getDaysOverdue(loan.loan_date);
            return (
              <tr key={loan.id} className="hover:bg-primary-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {loan.loan_number}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">{loan.first_name} {loan.last_name}</div>
                  <div className="text-sm text-gray-500">{loan.mobile_1}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {formatCurrency(loan.loan_amount)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {formatCurrency(loan.outstanding_amount)}
                </td>
                <td className={`px-6 py-4 whitespace-nowrap text-sm font-medium ${getOverdueColor(days)}`}>
                  {days} days
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    Active
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default OutstandingLoans;
